import { volquetesConstants } from '../_constants/volquetes.constants'

const INITIAL_STATE = {
  allVolquetes: [],
  availableVolquetes: [],
  allVolquetesObservations: [],
}

const volquetesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case volquetesConstants.GET_VOLQUETES:
      return {
        ...state,
        allVolquetes: action.payload,
      }
    case volquetesConstants.GET_AVAILABLE_VOLQUETES:
      return {
        ...state,
        availableVolquetes: action.payload,
      }
    case volquetesConstants.GET_VOLQUETES_OBSERVATIONS:
      return {
        ...state,
        allVolquetesObservations: action.payload,
      }

    default:
      return state
  }
}

export default volquetesReducer
